module.exports = __webpack_public_path__ + "img/lianxi1.6c1af7d6.png";